<template>
  <div class="video">
    <div class="header-img">
      <img src="http://bernouly.oss-cn-beijing.aliyuncs.com/images/download/banner.png" alt />
    </div>
    <div class="toobar">
      1+X垃圾焚烧发电运行与维护职业技能等级证书试点工作线上说明会
    </div>
    <div class="middle">
      <div class="wenzi" style="margin: 0px auto;width: 1100px;padding-top: 30px;">
        <div style="font-family: simhei;font-size: 18px;color: #4b4b4b;margin-bottom: 40px;text-indent:2em;">
			<span style="line-height:24px">2020年4月11日，博努力（北京）仿真技术有限公司组织召开了“1+X”垃圾焚烧发电运行与维护职业技能等级证书试点工作线上说明会。本次说明会邀请了国内知名行业专家、职教专家以及相关院校领导出席，共有八十多所院校和企业的人员在线参与会议。</span>
		</div>
		<div style="text-align: center;padding-bottom: 30px;">
			<video src="https://bernouly.oss-cn-beijing.aliyuncs.com/mp4/%E5%8D%9A%E5%8A%AA%E5%8A%9B1%2BX%E8%AF%81%E4%B9%A6%E7%BA%BF%E4%B8%8A%E8%AF%B4%E6%98%8E%E4%BC%9A_720P.mp4" controls="controls" controlslist="nodownload" width="1100px" height="620px" ></video>
		</div>
		<div style="padding-bottom: 30px;">
			<img src="https://bernouly.oss-cn-beijing.aliyuncs.com/certificate/biaoge.png" alt="">
		</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>
<style scoped>
.video {
  background: #ffffff;
}

.video img {
    display: inline-block;
}

.video .header-img {
  width: 100%;
  height: 237px;
}

.video .header-img img {
  width: 100%;
  height: 100%;
}

.video .middle {
  width: 100%;
  /* height: 680px; */
}

.video .toobar {
  height: 90px;
  text-align: center;
  line-height: 90px;
  font-size: 34px;
  color: #333333;
  background-color: #e1e1e1;
}

.video .middle img:hover {
  cursor: pointer;
}

.video a {
  color: #fefefe;
  text-decoration: none;
}

.video a:hover {
  cursor: pointer;
}

.video li {
  width: 100px;
  height: 80px;
  color: #fefefe;
  line-height: 80px;
  text-align: center;
  cursor: pointer;
  font-size: 16px;
  display: list-item;
}

.video li:hover {
  background: #0a57f4;
}
</style>